import { Pinia, Store } from 'pinia-class-component';
import { LinkCollection, LinksApiUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'LinkCollectionStore',
  name: 'LinkCollectionStore',
})
export default class LinkCollectionStore extends Pinia {
  private readonly api = initClient(LinksApiUiClient);

  //data
  private _loadingPromise: Promise<LinkCollection[]> | null = null;
  private _collections: LinkCollection[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get collections(): LinkCollection[] {
    return this._collections;
  }

  get collectionsById(): Map<string, LinkCollection> {
    return new Map(this._collections.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._collections.splice(0);
  }

  setCollections(cells: LinkCollection[]): void {
    this._collections.splice(0);
    this._collections.push(...cells);
  }

  addCollection(collection: LinkCollection): void {
    this._collections.push(collection);
  }

  updateCollection(collection: LinkCollection): void {
    const index = this._collections.findIndex(e => e.id === collection.id);
    if (index >= 0) {
      this._collections.splice(index, 1, collection);
    } else {
      this._collections.push(collection);
    }
  }

  forgetCollection(collection: LinkCollection): void {
    const index = this._collections.findIndex(e => e.id === collection.id);
    if (index >= 0) {
      this._collections.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const cells = await this._loadingPromise;
      this.setCollections(cells);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._collections.length > 0) {
      return;
    }
    return await this.reload();
  }
}